module.exports = __webpack_public_path__ + "static/media/circle-left-gray.408cdc4d.svg";